// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay for full-screen modal */
.upiIdTextBox_overlay__FcZSR {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0;
}

/* Backdrop with blur effect */
.upiIdTextBox_backdrop__SCCyD {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

.upiIdTextBox_wrapper__iPoL4 {
    position: relative;
    z-index: 10000;
    position: relative;
    z-index: 10000;
    display: flex;
    width: 100%;
    max-width: 100vw;
    padding: 20px;
    max-width: 100vw;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    border-radius: 20px 20px 0 0;
    background: #22242B;
    box-sizing: border-box;
    flex-shrink: 0;
    min-height: 275px;
    visibility: visible;
    opacity: 1;
    margin-top: auto;
}

.upiIdTextBox_title__QJSM0 {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #f3f4f6;
    margin: 0;
    width: 100%;
}

.upiIdTextBox_inputWrapper__G2S8g {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
}

.upiIdTextBox_inputContainer__YRyMQ {
    position: relative;
    width: 100%;
}

.upiIdTextBox_inputContainerError__25vB2 .upiIdTextBox_input__3IVdj {
    border-color: #EF4444 !important;
}

.upiIdTextBox_floatingLabel__yEO0d {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-family: 'Noto Sans', sans-serif;
    font-size: 16px;
    color: rgba(243, 244, 246, 0.5);
    pointer-events: none;
    transition: all 0.2s ease;
    background: transparent;
    padding: 0 4px;
}

.upiIdTextBox_floatingLabelActive__DOL2X {
    top: -8px;
    transform: translateY(0);
    font-size: 12px;
    color: rgba(243, 244, 246, 0.7);
    background: #22242B; 
    padding: 0 4px;
}

.upiIdTextBox_floatingLabelError__6woPD {
    color: #EF4444 !important;
}

.upiIdTextBox_input__3IVdj {
    display: flex;
    width: 100%;
    height: 56px;
    padding: 0 16px;
    padding-right: 48px;
    align-items: center;
    font-size: 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    background-color: #353945;
    color: #f3f4f6;
    outline: none;
    transition: border-color 0.2s;
    font-family: 'Noto Sans', sans-serif;
    box-sizing: border-box;
}

.upiIdTextBox_input__3IVdj:focus {
    border-color: rgba(255, 255, 255, 0.4);
}

.upiIdTextBox_inputError__ruw9r {
    border-color: #EF4444 !important;
}

.upiIdTextBox_errorIcon__5exHW {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.upiIdTextBox_errorMessage__AVGYM {
    font-family: 'Noto Sans', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #EF4444;
    margin: 0;
    padding-left: 16px;
}

/* Prevent browser autofill from changing colors */
.upiIdTextBox_input__3IVdj:-webkit-autofill,
.upiIdTextBox_input__3IVdj:-webkit-autofill:hover,
.upiIdTextBox_input__3IVdj:-webkit-autofill:focus,
.upiIdTextBox_input__3IVdj:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #353945 inset !important;
    -webkit-text-fill-color: #f3f4f6 !important;
    box-shadow: 0 0 0 1000px #353945 inset !important;
    background-color: #353945 !important;
    color: #f3f4f6 !important;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
}

.upiIdTextBox_chips__J4f39 {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.upiIdTextBox_chips__J4f39::-webkit-scrollbar {
    display: none;
}

.upiIdTextBox_chip__1bSzW {
    display: flex;
    padding: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    border: 1px solid #4F5568;
    background-color: transparent;
    color: #f3f4f6;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    font-family: 'Noto Sans', sans-serif;
    white-space: nowrap;
    flex-shrink: 0;
    outline: none;
}

.upiIdTextBox_chip__1bSzW:hover {
    background-color: rgba(79, 85, 104, 0.3);
    border-color: #6B7280;
}

.upiIdTextBox_chip__1bSzW:active {
    transform: scale(0.95);
}

.upiIdTextBox_chip__1bSzW:focus {
    outline: none;
    background-color: transparent;
    border-color: #4F5568;
    transform: scale(1);
}

.upiIdTextBox_chip__1bSzW:focus-visible {
    outline: none;
}

.upiIdTextBox_payButton__n9UwD {
    display: flex;
    height: 56px;
    padding: 0 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    width: 100%;
    border-radius: 16px;
    background: #353945;
    color: #8b8d98;
    border: none;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Noto Sans', sans-serif;
    text-align: center;
    box-sizing: border-box;
}

.upiIdTextBox_payButton__n9UwD:hover:not(:disabled) {
    background: #4a4d5a;
}

.upiIdTextBox_payButton__n9UwD:active:not(:disabled) {
    transform: scale(0.98);
}

.upiIdTextBox_payButton__n9UwD:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

/* When Pay button is enabled (has valid UPI) */
.upiIdTextBox_payButtonActive__6gUaP {
    background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%) !important;
    color: #0D0E11 !important;
}

.upiIdTextBox_payButtonActive__6gUaP:hover {
    background: #F0F0F0 !important;
}

/* Overlay for backdrop blur */
.upiIdTextBox_overlay__FcZSR {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 9999;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0;
    overflow-y: auto;
}

/* Error states */
.upiIdTextBox_inputContainerError__25vB2 {
    border-color: #FF4444 !important;
}

.upiIdTextBox_inputContainerError__25vB2 .upiIdTextBox_input__3IVdj {
    border-color: #FF4444 !important;
}

.upiIdTextBox_errorIcon__5exHW {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
}

.upiIdTextBox_errorMessage__AVGYM {
    color: #FF4444;
    font-size: 12px;
    font-family: 'Noto Sans', sans-serif;
    margin: -8px 0 0 0;
    padding: 0 16px;
}

/* Mobile responsive */
@media (min-width: 500px) {
    .upiIdTextBox_wrapper__iPoL4 {
        max-width: 500px;
        border-radius: 20px;
    }
    
    .upiIdTextBox_overlay__FcZSR {
        align-items: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/pwatv/UpiIdTextBox/upiIdTextBox.module.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,UAAU;AACd;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,oCAAoC;IACpC,eAAe;IACf,+BAA+B;IAC/B,oBAAoB;IACpB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,wBAAwB;IACxB,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,kBAAkB;AACtB;;AAEA,kDAAkD;AAClD;;;;IAII,yDAAyD;IACzD,2CAA2C;IAC3C,iDAAiD;IACjD,oCAAoC;IACpC,yBAAyB;IACzB,yDAAiD;IAAjD,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB,EAAE,+BAA+B;IACtD,wBAAwB,EAAE,mCAAmC;AACjE;;AAEA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,+CAA+C;AAC/C;IACI,0EAA0E;IAC1E,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/* Overlay for full-screen modal */\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    padding: 0;\n}\n\n/* Backdrop with blur effect */\n.backdrop {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n}\n\n.wrapper {\n    position: relative;\n    z-index: 10000;\n    position: relative;\n    z-index: 10000;\n    display: flex;\n    width: 100%;\n    max-width: 100vw;\n    padding: 20px;\n    max-width: 100vw;\n    padding: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    border-radius: 20px 20px 0 0;\n    background: #22242B;\n    box-sizing: border-box;\n    flex-shrink: 0;\n    min-height: 275px;\n    visibility: visible;\n    opacity: 1;\n    margin-top: auto;\n}\n\n.title {\n    font-family: 'Noto Sans', sans-serif;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 24px;\n    color: #f3f4f6;\n    margin: 0;\n    width: 100%;\n}\n\n.inputWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n}\n\n.inputContainer {\n    position: relative;\n    width: 100%;\n}\n\n.inputContainerError .input {\n    border-color: #EF4444 !important;\n}\n\n.floatingLabel {\n    position: absolute;\n    left: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-family: 'Noto Sans', sans-serif;\n    font-size: 16px;\n    color: rgba(243, 244, 246, 0.5);\n    pointer-events: none;\n    transition: all 0.2s ease;\n    background: transparent;\n    padding: 0 4px;\n}\n\n.floatingLabelActive {\n    top: -8px;\n    transform: translateY(0);\n    font-size: 12px;\n    color: rgba(243, 244, 246, 0.7);\n    background: #22242B; \n    padding: 0 4px;\n}\n\n.floatingLabelError {\n    color: #EF4444 !important;\n}\n\n.input {\n    display: flex;\n    width: 100%;\n    height: 56px;\n    padding: 0 16px;\n    padding-right: 48px;\n    align-items: center;\n    font-size: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 12px;\n    background-color: #353945;\n    color: #f3f4f6;\n    outline: none;\n    transition: border-color 0.2s;\n    font-family: 'Noto Sans', sans-serif;\n    box-sizing: border-box;\n}\n\n.input:focus {\n    border-color: rgba(255, 255, 255, 0.4);\n}\n\n.inputError {\n    border-color: #EF4444 !important;\n}\n\n.errorIcon {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n}\n\n.errorMessage {\n    font-family: 'Noto Sans', sans-serif;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    color: #EF4444;\n    margin: 0;\n    padding-left: 16px;\n}\n\n/* Prevent browser autofill from changing colors */\n.input:-webkit-autofill,\n.input:-webkit-autofill:hover,\n.input:-webkit-autofill:focus,\n.input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 1000px #353945 inset !important;\n    -webkit-text-fill-color: #f3f4f6 !important;\n    box-shadow: 0 0 0 1000px #353945 inset !important;\n    background-color: #353945 !important;\n    color: #f3f4f6 !important;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\n.chips {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 10px;\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none; /* Hide scrollbar for Firefox */\n    -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.chips::-webkit-scrollbar {\n    display: none;\n}\n\n.chip {\n    display: flex;\n    padding: 8px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    border-radius: 8px;\n    border: 1px solid #4F5568;\n    background-color: transparent;\n    color: #f3f4f6;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-family: 'Noto Sans', sans-serif;\n    white-space: nowrap;\n    flex-shrink: 0;\n    outline: none;\n}\n\n.chip:hover {\n    background-color: rgba(79, 85, 104, 0.3);\n    border-color: #6B7280;\n}\n\n.chip:active {\n    transform: scale(0.95);\n}\n\n.chip:focus {\n    outline: none;\n    background-color: transparent;\n    border-color: #4F5568;\n    transform: scale(1);\n}\n\n.chip:focus-visible {\n    outline: none;\n}\n\n.payButton {\n    display: flex;\n    height: 56px;\n    padding: 0 24px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    align-self: stretch;\n    width: 100%;\n    border-radius: 16px;\n    background: #353945;\n    color: #8b8d98;\n    border: none;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-family: 'Noto Sans', sans-serif;\n    text-align: center;\n    box-sizing: border-box;\n}\n\n.payButton:hover:not(:disabled) {\n    background: #4a4d5a;\n}\n\n.payButton:active:not(:disabled) {\n    transform: scale(0.98);\n}\n\n.payButton:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n/* When Pay button is enabled (has valid UPI) */\n.payButtonActive {\n    background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%) !important;\n    color: #0D0E11 !important;\n}\n\n.payButtonActive:hover {\n    background: #F0F0F0 !important;\n}\n\n/* Overlay for backdrop blur */\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    z-index: 9999;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    padding: 0;\n    overflow-y: auto;\n}\n\n/* Error states */\n.inputContainerError {\n    border-color: #FF4444 !important;\n}\n\n.inputContainerError .input {\n    border-color: #FF4444 !important;\n}\n\n.errorIcon {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n}\n\n.errorMessage {\n    color: #FF4444;\n    font-size: 12px;\n    font-family: 'Noto Sans', sans-serif;\n    margin: -8px 0 0 0;\n    padding: 0 16px;\n}\n\n/* Mobile responsive */\n@media (min-width: 500px) {\n    .wrapper {\n        max-width: 500px;\n        border-radius: 20px;\n    }\n    \n    .overlay {\n        align-items: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `upiIdTextBox_overlay__FcZSR`,
	"backdrop": `upiIdTextBox_backdrop__SCCyD`,
	"wrapper": `upiIdTextBox_wrapper__iPoL4`,
	"title": `upiIdTextBox_title__QJSM0`,
	"inputWrapper": `upiIdTextBox_inputWrapper__G2S8g`,
	"inputContainer": `upiIdTextBox_inputContainer__YRyMQ`,
	"inputContainerError": `upiIdTextBox_inputContainerError__25vB2`,
	"input": `upiIdTextBox_input__3IVdj`,
	"floatingLabel": `upiIdTextBox_floatingLabel__yEO0d`,
	"floatingLabelActive": `upiIdTextBox_floatingLabelActive__DOL2X`,
	"floatingLabelError": `upiIdTextBox_floatingLabelError__6woPD`,
	"inputError": `upiIdTextBox_inputError__ruw9r`,
	"errorIcon": `upiIdTextBox_errorIcon__5exHW`,
	"errorMessage": `upiIdTextBox_errorMessage__AVGYM`,
	"chips": `upiIdTextBox_chips__J4f39`,
	"chip": `upiIdTextBox_chip__1bSzW`,
	"payButton": `upiIdTextBox_payButton__n9UwD`,
	"payButtonActive": `upiIdTextBox_payButtonActive__6gUaP`
};
export default ___CSS_LOADER_EXPORT___;
